import { type FC } from "react";

import { css } from "@emotion/css";
import { Button } from "@snapchat/snap-design-system";

import { Flexbox } from "../../core/components";

interface LoadMoreProps {
    onClick: () => void;
    loading: boolean;
    isLastPage: boolean;
}

const loadMore = css`
    height: 20px;
    margin: 25px 0 50px;
`;

export const LoadMore: FC<LoadMoreProps> = ({ onClick, loading, isLastPage }) => (
    <Flexbox className={loadMore} justifyContent="center">
        {isLastPage ? null : (
            <Button isPending={loading} onClick={onClick}>
                Load More
            </Button>
        )}
    </Flexbox>
);
